import { render, staticRenderFns } from "./AboutPanel.vue?vue&type=template&id=041a2a44&"
import script from "./AboutPanel.vue?vue&type=script&lang=js&"
export * from "./AboutPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports